import React, { Component } from 'react';

import { Icon } from 'semantic-ui-react';
import '../../assets/css/carouselCursos.css';

import { producaov2 } from '../../services/apis';

import Topo from '../../components/Topo';
import TopoParceiros from '../../components/TopoParceiros';
import Footer from '../../components/Footer';

import Section from '../../components/Section';

import CarroselPersonalizavel from '../../components/CarroselPersonalizavel';
import VisibilitySensor from 'react-visibility-sensor';

import { verify_mobile } from '../../utils/Utils';
import Carousel from '../../components/Carousel';
import CarouselButton from '../../components/CarouselButton';

class QuarentenaGratuitos extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      cursos: [],
      pdfs: [],
      isPremium: false
    }
  }

  orderCursos(cursos) {
    return cursos.sort((a, b) => { return a.ordem - b.ordem; });
  }

  onChangeVisibility(isVisible, element, funcao = '') {
    if (funcao != '' && isVisible && this.state[element] == false) {
      this[funcao]();
    }
    if (isVisible && this.state[element] == false) {
      this.setState({ [element]: true });
    }
  }

  componentDidMount() {
    producaov2("/carousel/ofertas?areas=14,15").then((res) => {
      const carrosselOrder = res.data.sort((a, b) => { return a.ordem - b.ordem; })
      this.setState({ cursos: carrosselOrder });
    })

    producaov2.get('/materiais/gratuitos').then((res) => {
      this.setState({ pdfs: res.data });
    })

    const { area } = this.props.match.params;

    producaov2.get(`/ead_parceiro/${area}`).then((response) => {
      const parceiro = response.data.parceiro;

      if (!parceiro) return;

      this.setState({
        parceiro: parceiro.url,
        paginaParceiros: true
      });
    });
  }

  render() {
    return (
      <div style={{ background: '#212121' }}>
        <style>
          {
            `
              html{
                background: #212121
              }

              .titulos_font_workshops_primeiro{
                color: white;
              }

              .titulos_font_workshops{
                color: white;
              }

              #botao-controle{
                background-color: transparent;
                color: white !important;
                cursor: pointer !important;
                font-size: 2em !important;
                margin-right: -10px !important;
                margin-left: -10px !important;
                align-self: center !important;
              }

              #botao-controle:hover{
                /*background-color: #F1F1F1 !important;*/
                opacity: 0.70 !important;
              }

              i.circular.icon{
                -webkit-box-shadow: 0em 0em 0em 0em rgba(0, 0, 0, 0.1) inset !important;
                box-shadow: 0em 0em 0em 0em !important;
              }
                    
              .slider-control-centerright button{
                cursor:pointer !important;
                background-color:#F2711C !important;
                border: none !important;
                max-height: 180px !important;
                color: white !important;
              }
                  
              .slider-control-centerleft button{
                  cursor:pointer !important;
                  background-color:#F2711C !important;
                  border: none !important;
                  max-height: 180px !important;
                  color: white !important;
                }

                .slider-control-centerleft button span{
                  font-size: 40pt !important;
                }

                .slider-control-centerright button span{
                  font-size: 40pt !important;
                }

                .ui.image img {
                  height: 100% !important;
                }

                .pocket_img {
                  width: 223px !important;
                  height: 344px !important;
                }

                .ui.image.dimmable {
                  height: 180px !important;
                }
            `
          }
        </style>



        <div style={{ marginTop: verify_mobile() ? '14%' : '2%' }}>
          {
            this.state.paginaParceiros == true ?
              <>
                <TopoParceiros parceiro={this.state.parceiro} />
                <img
                  className="bannerAll"
                  src="https://files.voitto.com.br/anexos/1598528078425gratuitos-quarentena-banner.jpeg"
                  style={{ marginTop: 42 }}
                />
              </> :
              <>
                <Topo />
                <img
                  className="bannerAll"
                  src="https://files.voitto.com.br/anexos/1598528078425gratuitos-quarentena-banner.jpeg"
                  style={{ marginTop: 21 }}
                />
              </>
          }

          {this.state.cursos.length ? (
            <>
              {
                !verify_mobile() ?
                  this.state.paginaParceiros
                    ? this.state.cursos.map((res) => (
                      <div className="corpo large_carrosel_div" >
                        <p
                          className="titulos_font big-margin-top programas-em-destaque-title"
                          style={{
                            fontFamily: 'Montserrat',
                            fontSize: 22,
                            fontWeight: 600,
                            color: '#FFFFFF',
                            textTransform: 'capitalize'
                          }}
                        >
                          {res.area}
                        </p>
                        <Carousel
                          venda={true}
                          blackfriday={true}
                          parceiro={this.state.parceiro}
                          slidesToShow={4}
                          slidesToScroll={1}
                          wrapAround={false}
                          padding={"3%"}
                          cursos={res.carouselvenda}
                          area={"ofertas"}
                          botaoEsquerdo={({ previousSlide }) =>
                            <CarouselButton
                              direction='left'
                              changeSlide={previousSlide}
                            />
                          }

                          botaoDireito={({ nextSlide }) =>
                            <CarouselButton
                              direction='right'
                              changeSlide={nextSlide}
                            />
                          }
                        />
                      </div>
                    ))
                    : this.state.cursos.map((res) => (
                      <div className="corpo large_carrosel_div" >
                        <p
                          className="titulos_font big-margin-top programas-em-destaque-title"
                          style={{
                            fontFamily: 'Montserrat',
                            fontSize: 22,
                            fontWeight: 600,
                            color: '#FFFFFF',
                            textTransform: 'capitalize'
                          }}
                        >
                          {res.area}
                        </p>
                        <Carousel
                          venda={true}
                          blackfriday={true}
                          slidesToShow={4}
                          slidesToScroll={1}
                          wrapAround={false}
                          padding={"3%"}
                          cursos={res.carouselvenda}
                          area={"ofertas"}
                          botaoEsquerdo={({ previousSlide }) =>
                            <CarouselButton
                              direction='left'
                              changeSlide={previousSlide}
                            />
                          }

                          botaoDireito={({ nextSlide }) =>
                            <CarouselButton
                              direction='right'
                              changeSlide={nextSlide}
                            />
                          }
                        />
                      </div>
                    ))
                  : this.state.paginaParceiros
                    ? this.state.cursos.map((res) => (
                      <div className="corpo large_carrosel_div" >
                        <p
                          className="titulos_font big-margin-top programas-em-destaque-title"
                          style={{
                            fontFamily: 'Montserrat',
                            fontSize: 22,
                            fontWeight: 600,
                            color: '#FFFFFF',
                            textTransform: 'capitalize'
                          }}
                        >
                          {res.area}
                        </p>
                        <Carousel
                          venda={true}
                          blackfriday={true}
                          parceiro={this.state.parceiro}
                          slidesToShow={1}
                          slidesToScroll={1}
                          wrapAround={false}
                          cursos={res.carouselvenda}
                          area={"programas_em_destaque"}

                          botaoEsquerdo={({ previousSlide }) =>
                            <CarouselButton
                              direction='left'
                              changeSlide={previousSlide}
                            />
                          }

                          botaoDireito={({ nextSlide }) =>
                            <CarouselButton
                              direction='right'
                              changeSlide={nextSlide}
                            />
                          }
                        />
                      </div>
                    ))
                    : this.state.cursos.map((res) => (
                      <div className="corpo large_carrosel_div">
                        <p
                          className="titulos_font big-margin-top programas-em-destaque-title"
                          style={{
                            fontFamily: 'Montserrat',
                            fontSize: 22,
                            fontWeight: 600,
                            color: '#FFFFFF',
                            textTransform: 'capitalize'
                          }}
                        >
                          {res.area}
                        </p>
                        <Carousel
                          venda={true}
                          blackfriday={true}
                          slidesToShow={1}
                          slidesToScroll={1}
                          wrapAround={false}
                          cursos={res.carouselvenda}
                          area={"programas_em_destaque"}

                          botaoEsquerdo={({ previousSlide }) =>
                            <CarouselButton
                              direction='left'
                              changeSlide={previousSlide}
                            />
                          }

                          botaoDireito={({ nextSlide }) =>
                            <CarouselButton
                              direction='right'
                              changeSlide={nextSlide}
                            />
                          }
                        />
                      </div>
                    ))
              }

              {
                this.state.paginaParceiros
                  ? this.state.pdfs.length && (
                    <div className="corpo large_carrosel_div">
                      <p
                        className="titulos_font big-margin-top programas-em-destaque-title"
                        style={{
                          fontFamily: 'Montserrat',
                          fontSize: 22,
                          fontWeight: 600,
                          color: '#FFFFFF',
                          textTransform: 'capitalize'
                        }}
                      >
                        Ebooks gratuitos
                    </p>

                      <CarroselPersonalizavel
                        slidesToShow={1}
                        slidesToScroll={1}
                        wrapAround={true}
                        padding={"3%"}
                        cursos={this.state.pdfs}
                        parceiro={this.state.parceiro}
                        pdf={true}
                        area={"ofertas"}

                        botaoEsquerdo={({ previousSlide }) =>
                          <CarouselButton
                            direction='left'
                            changeSlide={previousSlide}
                          />
                        }

                        botaoDireito={({ nextSlide }) =>
                          <CarouselButton
                            direction='right'
                            changeSlide={nextSlide}
                          />
                        }

                      />

                      <VisibilitySensor onChange={(isVisible) => this.onChangeVisibility(isVisible, 'DASHBOARDS', '')}>
                        <div style={{ width: '100vw', height: 1 }} className="depoimentos_dispare"></div>
                      </VisibilitySensor>
                    </div>
                  )
                  : this.state.pdfs.length && (
                    <div className="corpo large_carrosel_div">
                      <p
                        className="titulos_font big-margin-top programas-em-destaque-title"
                        style={{
                          fontFamily: 'Montserrat',
                          fontSize: 22,
                          fontWeight: 600,
                          color: '#FFFFFF',
                          textTransform: 'capitalize'
                        }}
                      >
                        Ebooks gratuitos
                    </p>
                      <CarroselPersonalizavel
                        slidesToShow={1}
                        slidesToScroll={1}
                        wrapAround={true}
                        padding={"3%"}
                        cursos={this.state.pdfs}
                        parceiro={this.state.parceiro}
                        pdf={true}
                        area={"ofertas"}

                        botaoEsquerdo={({ previousSlide }) =>
                          <CarouselButton
                            direction='left'
                            changeSlide={previousSlide}
                          />
                        }

                        botaoDireito={({ nextSlide }) =>
                          <CarouselButton
                            direction='right'
                            changeSlide={nextSlide}
                          />
                        }

                      />

                      <VisibilitySensor onChange={(isVisible) => this.onChangeVisibility(isVisible, 'DASHBOARDS', '')}>
                        <div style={{ width: '100vw', height: 1 }} className="depoimentos_dispare"></div>
                      </VisibilitySensor>
                    </div>
                  )
              }
            </>
          ) : ''}

          {!verify_mobile() ? <Section /> : null}

        </div>

        {!this.props.isHome && (
          <Footer />
        )}
      </div>
    )
  }
}

export default QuarentenaGratuitos;
